<!-- Single page tab -->
<div
  class="flex items-center p-6 text-lg font-medium"
  [class]="{
    'bg-midnight': isActive,
    'text-primary-content': isActive,
    'text-midnight': !isActive,
    'bg-neutral-secondary': !isActive,
    'cursor-pointer': !!routerLink
  }"
  [routerLink]="routerLink"
  routerLinkActive="!text-primary-content !bg-midnight"
>
  <ng-content></ng-content>
</div>
